import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";

import { PrivateRoute } from "helper/route";
import LayoutContainer from "containers/Layout";

// pages
import MarketUpdates from "pages/KnowledgeCentre/MarketUpdates";
import NewsAndArticles from "pages/KnowledgeCentre/NewsAndArticles";
import NewsAndArticleContent from "pages/KnowledgeCentre/NewsAndArticleContent";
import HelpSupport from "pages/KnowledgeCentre/HelpSupport";

const CustomerNavigator = (props) => {
  const { match } = props;
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );

  const auth = { isAuthenticated };

  return (
    <Switch>
      <Redirect exact from={match.path} to="/customer/blogs" />
      <LayoutContainer {...props}>
        <Switch>
          {/* Prefer All-In-One shell route so navbar stays consistent */}
          <Redirect exact from={`${match.path}/blogs`} to="/customer/blogs" />
          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/market-updates`}
            component={MarketUpdates}
          />
          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/news-articles`}
            component={NewsAndArticles}
          />
          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/news-articles/:articleId`}
            component={NewsAndArticleContent}
          />
          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/help-support`}
            component={HelpSupport}
          />
        </Switch>
      </LayoutContainer>
      <Redirect to={`not-found`} />
    </Switch>
  );
};

export default CustomerNavigator;
